import { Helmet } from "react-helmet-async";

export default function PolitiqueConfidentialitePage() {
  return (
    <>
      <Helmet>
        <title>Politique de confidentialité | FLOW</title>
        <meta name="description" content="Politique de confidentialité et protection des données personnelles — FLOW, climatisation et ventilation." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://flow-air.com/politique-de-confidentialite" />
      </Helmet>

      <section className="py-16 md:py-24 bg-white" data-testid="politique-confidentialite-page">
        <div className="container-flow max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-[#0E1A2B] mb-10 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
            Politique de confidentialité
          </h1>

          <div className="space-y-10 text-[#475569] leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Responsable du traitement</h2>
              <p>FLOW (FLOW) — <a href="mailto:contact@flow-air.com" className="text-[#00AFFF] hover:underline">contact@flow-air.com</a></p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Données collectées</h2>
              <p>Uniquement via le formulaire de contact : nom, prénom, email, téléphone, objet de la demande. Aucune donnée collectée par cookie ou tracker tiers.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Finalité</h2>
              <p>Répondre aux demandes entrantes. Aucune utilisation commerciale, aucun transfert à des tiers.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Durée de conservation</h2>
              <p>3 ans à compter du dernier contact.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0E1A2B] mb-3" style={{ fontFamily: 'Sora, sans-serif' }}>Vos droits (RGPD)</h2>
              <p>Droit d'accès, rectification, suppression, opposition. Demande à adresser à : <a href="mailto:contact@flow-air.com" className="text-[#00AFFF] hover:underline">contact@flow-air.com</a>.</p>
              <p>Réclamation possible auprès de la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#00AFFF] hover:underline">https://www.cnil.fr</a></p>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}
